import { Permission } from '@breathelife/types';

import ApiService from '../ApiService';

export async function fetchUserPermissions(): Promise<Permission[]> {
  const response = await ApiService.admin.fetchUserPermissions();
  return response.data || [];
}
